__turbopack_context__.v({
  "className": "eoa4ia_className",
  "variable": "eoa4ia_variable",
});
